{
  "catalogue": {
    "searchPlaceholder": "اسم الصنف أو رمزه",
    "resultCount": "عدد النتائج: {{count}}",
    "emptyNone": "لا توجد أصناف متاحة لوحدة الشراء الخاصة بك بعد",
    "emptyHint": "تحقّق من الكتابة، أو امسح البحث والتصفية لعرض كل الأصناف.",
    "pageEmpty": "لا توجد أصناف في هذه الصفحة",
    "firstPage": "الانتقال إلى الصفحة الأولى",
    "noResults": "لا نتائج لهذا البحث"
  }
}
